import Vue from 'vue'
import vSelect from 'vue-select'
import '~/node_modules/vue-select/dist/vue-select.css'

Vue.component('VSelect', vSelect)
